import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Layout from '../components/Layout';
import { Card, CardHeader, CardBody, Button, Table, Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

const BusinessClosures = () => {
    const [closures, setClosures] = useState([]);
    const [newClosure, setNewClosure] = useState({
        date: null,
        reason: ''
    });
    const [editingId, setEditingId] = useState(null);
    const [editedClosure, setEditedClosure] = useState({});

    useEffect(() => {
        fetchClosures();
    }, []);

    const fetchClosures = async () => {
        try {
            const response = await api.get('/business-closures/');
            setClosures(response.data);
        } catch (error) {
            console.error('Error fetching closures:', error);
        }
    };

    const addClosure = async () => {
        try {
            await api.post('/business-closures/', {
                ...newClosure,
                date: newClosure.date ? newClosure.date.toISOString().split('T')[0] : null
            });
            fetchClosures();
            setNewClosure({
                date: null,
                reason: ''
            });
        } catch (error) {
            console.error('Error adding closure:', error);
        }
    };

    const deleteClosure = async (id) => {
        try {
            await api.delete(`/business-closures/${id}/`);
            fetchClosures();
        } catch (error) {
            console.error('Error deleting closure:', error);
        }
    };

    const startEditing = (closure) => {
        setEditingId(closure.id);
        setEditedClosure({ ...closure, date: new Date(closure.date) });
    };

    const cancelEditing = () => {
        setEditingId(null);
        setEditedClosure({});
    };

    const saveEditedClosure = async () => {
        try {
            await api.put(`/business-closures/${editingId}/`, {
                ...editedClosure,
                date: editedClosure.date ? editedClosure.date.toISOString().split('T')[0] : null
            });
            setEditingId(null);
            setEditedClosure({});
            fetchClosures();
        } catch (error) {
            console.error('Error saving closure:', error);
        }
    };

    return (
        <Layout>
            <div style={{ padding: '1rem' }}>
                <Card>
                    <CardHeader tag="h3">Business Closures</CardHeader>
                    <CardBody>
                        <Table bordered hover striped>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Reason</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {closures.length === 0 ? (
                                    <tr>
                                        <td colSpan="3">No closures found</td>
                                    </tr>
                                ) : (
                                    closures.map((closure) => (
                                        <tr key={closure.id}>
                                            <td>
                                                {editingId === closure.id ? (
                                                    <DatePicker
                                                        selected={editedClosure.date}
                                                        onChange={(date) => setEditedClosure(prev => ({ ...prev, date }))}
                                                        className="form-control"
                                                        dateFormat="MM/dd/yyyy"
                                                    />
                                                ) : (
                                                    moment(closure.date).format('MM/DD/YYYY')
                                                )}
                                            </td>
                                            <td>
                                                {editingId === closure.id ? (
                                                    <Input
                                                        type="textarea"
                                                        value={editedClosure.reason || ''}
                                                        onChange={(e) => setEditedClosure(prev => ({ ...prev, reason: e.target.value }))}
                                                    />
                                                ) : (
                                                    closure.reason || 'N/A'
                                                )}
                                            </td>
                                            <td>
                                                {editingId === closure.id ? (
                                                    <>
                                                        <Button color="success" size="sm" onClick={saveEditedClosure}>Save</Button>{' '}
                                                        <Button color="secondary" size="sm" onClick={cancelEditing}>Cancel</Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Button color="primary" size="sm" onClick={() => startEditing(closure)}>Edit</Button>{' '}
                                                        <Button color="danger" size="sm" onClick={() => deleteClosure(closure.id)}>Delete</Button>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                )}
                                <tr>
                                    <td>
                                        <DatePicker
                                            selected={newClosure.date}
                                            onChange={(date) => setNewClosure(prev => ({ ...prev, date }))}
                                            className="form-control"
                                            dateFormat="MM/dd/yyyy"
                                            placeholderText="Select a date"
                                        />
                                    </td>
                                    <td>
                                        <Input
                                            type="textarea"
                                            value={newClosure.reason}
                                            onChange={(e) => setNewClosure(prev => ({ ...prev, reason: e.target.value }))}
                                            placeholder="Reason"
                                        />
                                    </td>
                                    <td>
                                        <Button color="primary" size="sm" onClick={addClosure}>Add</Button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </div>
        </Layout>
    );
};

export default BusinessClosures;
